import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { connect, useSelector } from 'react-redux';
import { isEmpty, cloneDeep, get } from 'lodash';
import { toast } from 'react-toastify';
import * as featureService from 'features/fflip-helpers';
import useDeepCompareEffect from 'use-deep-compare-effect';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { FEATURES } from 'features/features';
import { translate } from 'containers/services/translate';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import * as util from 'containers/RecapManagerPage/utils';
import {
  SahamTabsGlobal,
  Container,
} from 'containers/LawyerLegalProceedingsPage/styled-components';
import LawyerRecap from 'containers/LawyerRecapPage/LawyerRecap';
import {
  CLAIM_STATUS,
  JUDICIARY_PROCESS_CORRECTIONAL_ID,
  LISTINGS,
} from 'containers/data-structure';
import { ITEM_KEYS, SAGIS_KEYS } from 'containers/RecapManagerPage/constants';
import GlobalLegalProceedingTabs from 'components/GlobalLegalProceedingTabs';
import {
  makeSelectKeycloakToken,
  makeSelectListings,
  makeSelectGlobalCurrentTabLawyer,
  makeSelectCurrentTabJudiciaryProcessLawyer,
  makeSelectCurrentTabLawyer,
} from 'containers/AppContainer/selectors';
import {
  makeSelecClaimRecap,
  makeSelectCorporealLawyers,
} from 'containers/RecapManagerPage/selectors';
import {
  requestClaimRecap,
  resetStoreClaim,
  setClaimRecap,
} from 'containers/RecapManagerPage/actions';
import {
  requestSearchClaims,
  resetSearchClaimsStore,
} from 'containers/IdentificationPage/actions';
import { makeSelectSearchClaims } from 'containers/IdentificationPage/selectors';
import {
  uploadDocument,
  resetUploadDocumentStore,
  setDocumentId,
  requestGetReportsPolicy,
} from 'containers/UploadDocuments/actions';
import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import { requestCorporealLawyers } from 'containers/RecapManagerPage/actions';
import {
  IUploadedDocument,
  IJudgementAdd,
  ICurrentSteps,
  JudgementOnMeritsType,
  IAppealPayload,
} from 'containers/LawyerLegalProceedingsPage/typings';
import {
  requestCreateJudgementAdd,
  requestGetJudgementAdd,
  requestCreateExpertiseRaport,
  requestGetExpertiseRaport,
  requestCreateJudgementOnMerits,
  requestGetJudgementOnMerits,
  requestCreateJudgementAppeal,
  requestGetJudgementAppeal,
  requestGetDahirAmount,
  requestGetCivilProceeding,
  requestInsertDahirAmountJom,
  requestGetDahirAmountCorpo,
  updateContestation,
  requestUploadContestationDocument,
  requestGetJudgementAddAppeal,
  requestCreateCivilProceeding,
  requestCreateMultipleJudgementAdd,
  requestAddDocumentClaim,
  requestAddSupportDocument,
  requestCivilPartySupportDocument,
  requestAddExpertiseSupportDocument,
  requestAddJudgementOnMeritsSupportDocument,
  requestUpdateJudgementAdd,
  requestUpdateJudgementAddDocument,
  requestUpdateFirmReference,
  requestGetJudgementOnMeritsMultiple,
  requestGetAppealOnMeritsMultiple,
  resetLegalProceeding,
  requestGetExpertiseReportAppeal,
  resetLawyerSteps,
} from 'containers/LawyerLegalProceedingsPage/actions';
import {
  requestGetTransaction,
  requestGetContactTransaction,
  resetStoreTransaction,
  requestGetMissionTransaction,
  requestGetMissionVictimExpertise,
} from 'containers/TransactionManagerTimeLine/actions';
import { requestGetDocByDocumentumId } from 'containers/common/UploadDocument/actions';
import {
  makeSelectJudgementAdd,
  makeSelectExpertiseRaport,
  makeSelectJudgementOnMerits,
  makeSelectJudgementAppeal,
  makeSelectDahirAmounts,
  makeSelectCivilProceeding,
  makeSelectDahirAmountsCorpo,
  makeSelectJudgementAddAppeal,
  makeSelectJudgementOnMeritsMultiple,
  makeSelectAppealOnMeritsMultiple,
  makeSelectExpertiseRaportAppeal,
} from 'containers/LawyerLegalProceedingsPage/selectors';
import { StyledDiv } from 'containers/LawyerLegalProceedingsPage/styled-components';
import routesHelper from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import { getLegalProceedingsSteps } from 'containers/LawyerAssignmentsPage/actions';
import { makeSelectLegalProceedingsSteps } from 'containers/LawyerAssignmentsPage/selectors';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import { makeSelectCurrentInstanceTab } from 'containers/AppContainer/selectors';
import {
  setCurrentIndexTabTransaction,
  setCurrentInstanceTab,
} from 'containers/AppContainer/actions';
import LegalProceedingsPage from 'containers/LawyerLegalProceedingsPage/legalProceeding';
import JudiciaryProcessTabs from 'components/JudiciaryProcessTabs';
import { isManager } from 'containers/AppContainer/utils';
import TopCard from 'containers/LawyerLegalProceedingsPage/TopCard';
import {
  isJudiciaryProcessLawyerCode,
  constructLabelsWithIds,
  constructLabels,
  getCurrentTabJudiciaryProcess,
  containsCompletedTransaction,
  renderGlobalTabs,
  getContractorFeesByIntervenant,
  isLastInstructionLawyerMismatch,
} from 'containers/LawyerLegalProceedingsPage/utils';
import TransactionConsultation from 'containers/ConsultationLegalProceedingPage/Transaction';
import CivilProceeding from 'containers/LawyerLegalProceedingsPage/CivilProceeding';
import {
  requestMakeDecisionMissionExpertise,
  requestMakeDecisionMissionNoticeDeficiency,
  requestValidateExpertReport,
  requestValidateJudgementOnMerits,
  requestCreateInstruction,
  requestGetInstructions,
  requestUpdateInstruction,
  requestCreateIncomeCertificate,
  requestUpdateIncomeCertificate,
  requestGetClaimCivilParty,
  requestUpdateCivilProceeding,
} from 'containers/CourtManagerLegalProceedings/actions';
import UpdateFirmReferenceDialog from 'containers/LawyerLegalProceedingsPage/UpdateFirmReferenceInvoiceDialog';
import { STATUS_VALIDATED } from 'containers/LawyerFeeNote/constants';
import ExpertiseExpert from 'containers/CourtManagerLegalProceedings/ExpertiseExpert';
import { requestGetExpertiseVictim } from 'containers/ExpertExpertise/actions';
import { makeSelectVictimExpertise } from 'containers/ExpertExpertise/selectors';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { selectedLoader } from 'containers/AppContainer/Loader/selectors';
import { requestCreateFeeNote } from 'containers/LawyerFeeNote/actions';
import SuspiciousCard from 'containers/CourtManagerLegalProceedings/SuspiciousCard';
import { makeSelectSagisClaim } from 'containers/CourtManagerLegalProceedings/Provision/redux/selectors';
import {
  requestSagisClaimInfo,
  resetSagisInfoClaim,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import { extractOpposingParties } from 'containers/PreOpeningPage/utils';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import InstructionDrawer from 'containers/CourtManagerLegalProceedings/InstructionDrawer';
import {
  makeInstructions,
  makeSelectClaimCivilParty,
} from 'containers/CourtManagerLegalProceedings/selectors';
import WarningCard from 'containers/common/Card/WarningCard';
import { shouldShowVictimExcludedWarning } from 'helpers/utils';
import { isBlockStatusClaim } from 'containers/CourtManagerLegalProceedings/utils';
import DialogFeeNote from 'components/DialogFeeNote';
import { FeeNote } from 'containers/LawyerFeeNote/typings';
import {
  makeSelectCountFeeNotes,
  makeSelectFeeNotes,
  makeSelectAllFeeNotes,
} from 'containers/LawyerFeeNote/selectors';
import {
  requestFeeNotesByClaimNumb,
  requestAllFeeNotes,
  requestFeeNoteCosts,
  requestUpdateFeeNoteAmount,
  requestAddInvoiceFeeNote,
  requestUpdateInvoiceFeeNote,
} from 'containers/LawyerFeeNote/actions';
import { requestGetJudgements } from 'containers/common/LegalProceedings/actions';
import { ClaimRecapType } from 'typings/claimTypes';
import { makeSelectTransactions } from 'containers/TransactionManagerTimeLine/selector';
import { getLimitInvoiceIntervenant } from 'services/utils';

export interface LawyerLegalProceedingsPageProps {
  intl: IntlShape;
  location: { pathname: string };
  listings: Listings;
  storedClaimToPreopen: any;
  requestClaimRecap: Function;
  claimRecap: ClaimRecapType;
  policyInfo: { sagis: {} };
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  match: { params: { claimId: number; procedureType: string } };
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadDocumentStore: Function;
  requestCreateJudgementAdd: Function;
  requestGetJudgementAdd: Function;
  judgementAdd: IJudgementAdd | { status: string };
  sagis_code: string | undefined;
  currentSteps: ICurrentSteps[];
  getLegalProceedingsSteps: Function;
  documentId: string;
  setDocumentId: Function;
  requestCreateExpertiseRaport: Function;
  requestCreateJudgementOnMerits: Function;
  requestGetExpertiseRaport: Function;
  expertiseReport: ExpertReportType;
  requestGetJudgementOnMerits: Function;
  judgementOnMerits: JudgementOnMeritsType;
  requestCreateJudgementAppeal: Function;
  requestGetJudgementAppeal: Function;
  judgementAppeal: IAppealPayload;
  dahirAmount: [];
  requestGetDahirAmount: Function;
  currentTabInstance: string;
  setCurrentInstanceTab: Function;
  requestGetCivilProceeding: Function;
  requestCreateCivilProceeding: Function;
  civilProceeding: [];
  corporealLawyers: any;
  requestCorporealLawyers: Function;
  requestInsertDahirAmountJom: Function;
  requestGetDahirAmountCorpo: Function;
  updateContestation: Function;
  requestUploadContestationDocument: Function;
  dahirAmountsCorpo: any;
  requestGetJudgementAddAppeal: Function;
  requestCreateMultipleJudgementAdd: Function;
  judgementAddAppeal: any;
  requestAddDocumentClaim: Function;
  requestAddSupportDocument: Function;
  requestCivilPartySupportDocument: Function;
  requestAddExpertiseSupportDocument: Function;
  requestAddJudgementOnMeritsSupportDocument: Function;
  requestUpdateJudgementAdd: Function;
  requestValidateJudgementOnMerits: Function;
  requestValidateExpertReport: Function;
  requestUpdateJudgementAddDocument: Function;
  requestUpdateFirmReference: Function;
  setClaimRecap: Function;
  requestGetJudgementOnMeritsMultiple: Function;
  judgementOnMeritsMultiple: any;
  appealOnMeritsMultiple: any;
  requestGetAppealOnMeritsMultiple: Function;
  requestMakeDecisionMissionExpertise: Function;
  requestMakeDecisionMissionNoticeDeficiency: Function;
  requestCreateFeeNote: Function;
  requestGetExpertiseVictim: Function;
  requestSagisClaimInfo: Function;
  expertise: any;
  loaders: any;
  sagisInfo: any;
  resetLegalProceeding: Function;
  resetStoreClaim: Function;
  resetSagisInfoClaim: Function;
  requestGetInstructions: Function;
  requestCreateInstruction: Function;
  requestUpdateInstruction: Function;
  instructions: any;
  requestCreateIncomeCertificate: Function;
  expertiseRaportAppeal: any;
  requestGetExpertiseReportAppeal: Function;
  requestGetReportsPolicy: Function;
  requestUpdateIncomeCertificate: Function;
  requestGetClaimCivilParty: Function;
  claimCivilParty: any;
  allFeeNote: FeeNote[];
  feeNotes: FeeNote[];
  feeNotesCount: number;
  requestAllFeeNotes: Function;
  requestFeeNotesByClaimNumb: Function;
  requestFeeNoteCosts: Function;
  requestUpdateFeeNoteAmount: Function;
  requestAddInvoiceFeeNote: Function;
  requestUpdateInvoiceFeeNote: Function;
  requestGetDocByDocumentumId: Function;
  requestGetJudgements: Function;
  resetLawyerSteps: Function;
  globalCurrentTabLawyer: number | null;
  currentTabJudiciaryProcessLawyer: number | null;
  currentTabLawyer: number | null;
  requestGetMissionTransaction: Function;
  requestGetMissionVictimExpertise: Function;
  regulations: any;
  requestGetRegulations: Function;
  requestGetTransaction: Function;
  requestGetContactTransaction: Function;
  resetStoreTransaction: Function;
  setCurrentIndexTabTransaction: Function;
  requestUpdateCivilProceeding: Function;
}

export const LawyerLegalProceedingsPage: React.FC<LawyerLegalProceedingsPageProps> = (
  props,
): JSX.Element => {
  const [isInstructionDrawerOpen, setIsInstructionDrawerOpen] = useState<
    boolean
  >(false);
  const [updateCivilProcedure, setUpdateCivilProcedure] = useState(false);
  const [procedureInfo, setProcedureInfo] = useState({});

  const [instruction, setInstruction] = useState('');
  const transactions = useSelector(makeSelectTransactions());
  useEffect(() => {
    //clear all store data
    return () => {
      props.resetSearchClaimsStore();
      props.resetStoreClaim();
      props.resetLegalProceeding();
    };
  }, []);
  useEffect(() => {
    if (
      !isEmpty(props.claimRecap) &&
      ![STATUS_VALIDATED, CLAIM_STATUS.PENDING_APPROVAL].includes(
        get(props, 'claimRecap.claim.status'),
      )
    ) {
      isEmpty(get(props.claimRecap, 'claim.decidedBy', ''))
        ? toast.error(translate(messages.unvalidatedClaim, props))
        : toast.error(translate(messages.unvalidatedVictimsOrPa, props));
      routesHelper.pushTo(PAGES.LAWYER_ASSIGNMENTS)();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.claimRecap]);
  const [idCivilProceeding, setIdCivilProceeding] = React.useState<number>(0);
  const token = useSelector(makeSelectKeycloakToken());
  const [currentJudiciaryProcess, setCurrentJudiciaryProcess] = React.useState<
    any
  >({});

  const [dropDown, setDropDown] = React.useState<null | HTMLElement>(null);
  const [procedureType, setProcedureType] = React.useState<null | number>(null);
  const [
    isDialogOpenCivilProceeding,
    setIsDialogOpenCivilProceeding,
  ] = React.useState<boolean>(false);

  const [dialogOpenFirmReference, setDialogOpenFirmReference] = useState<any>(
    null,
  );

  const claimAssignment = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'assignment'], []),
  );
  const claimFeeNotes = useSelector((state: any) =>
    get(state.toJS(), ['recap', 'claimRecap', 'claim', 'feeNotes'], []),
  );

  const lawyerClaimAssignmentId = get(
    claimAssignment.find(
      (el: any) =>
        el.assignedLawyer === currentIntervenantStorage.get()?.sagis_code &&
        el.judiciaryProcessId === idCivilProceeding,
    ),
    'id',
    null,
  );

  const assignedLawyer =
    claimAssignment.find(
      (item: any) =>
        !item.isDeleted &&
        item.assignedLawyer === currentIntervenantStorage.get()?.sagis_code &&
        item.judiciaryProcessId === idCivilProceeding,
    ) || {};
  const lawyers = util.getListBySagisKey(
    get(props.listings, LISTINGS.STACKHOLDER_TYPE, []),
    get(props.listings, LISTINGS.STACKHOLDERS, []),
    ITEM_KEYS.LAWYER,
    SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
  ) as SagisConfig[];

  const handleOpenInstructions = () => {
    setIsInstructionDrawerOpen(true);

    const lawyerName = util.getLawyerById(
      lawyers,
      currentIntervenantStorage.get()?.sagis_code,
    );
    if (isLastInstructionLawyerMismatch(props.instructions)) {
      !isEmpty(props.instructions) &&
        props.requestUpdateInstruction(
          {
            readBy: lawyerName,
            judiciaryProcessId: idCivilProceeding,
            isLawyer: true,
          },
          successCallBack,
        );
    }
  };

  const successCallBack = () => {
    props.requestGetInstructions({
      judiciaryProcessId: idCivilProceeding,
    });
  };

  const toggleDrawerInstruction = () => {
    setInstruction('');
    setIsInstructionDrawerOpen(!isInstructionDrawerOpen);
  };
  useEffect(() => {
    const claimId = get(props, ['match', 'params', 'claimId']);
    props.requestGetCivilProceeding(claimId);
    props.requestClaimRecap(claimId);
    if (featureService.hasFeature(FEATURES.TRANSACTION)) {
      props.requestGetTransaction({ claimId, isIntervenant: true });
    }
    if (props.currentTabJudiciaryProcessLawyer) {
      setIdCivilProceeding(props.currentTabJudiciaryProcessLawyer);
    } else {
      const correctionnelProceeding = props.civilProceeding.filter(
        (element: { procedureNatureId: number }) =>
          element.procedureNatureId === JUDICIARY_PROCESS_CORRECTIONAL_ID,
      );
      setIdCivilProceeding(get(correctionnelProceeding, '[0].id', 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.match.params.claimId,
    !isEmpty(props.civilProceeding),
    token,
    props.currentTabJudiciaryProcessLawyer,
  ]);
  useEffect(() => {
    props.requestCorporealLawyers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!isEmpty(props.corporealLawyers), !token]);
  useEffect(() => {
    const assignedLawyers = get(
      props.claimRecap,
      ['claim', 'assignment'],
      [],
    ).map((el: any) => el.assignedLawyer);

    if (
      !isEmpty(assignedLawyers) &&
      props.sagis_code &&
      !assignedLawyers.includes(props.sagis_code) &&
      !isJudiciaryProcessLawyerCode(
        props.civilProceeding,
        props.sagis_code as any,
      ) //isJudiciaryProcessLawyerCode to delete
    ) {
      routesHelper.pushTo(PAGES.LAWYER_ASSIGNMENTS)();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.claimRecap, props.sagis_code]);
  const [stakeholders, setStakeholders] = React.useState([] as SagisConfig[]);
  useEffect(() => {
    const _stackholders = util.getListBySagisKey(
      get(props.listings, LISTINGS.STACKHOLDER_TYPE, []),
      get(props.listings, LISTINGS.STACKHOLDERS, []),
      ITEM_KEYS.LAWYER,
      SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
    );

    const lawyers = util.getBawabaLawyers(
      _stackholders,
      props.corporealLawyers,
    );
    setStakeholders(lawyers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.listings]);
  const labels = renderGlobalTabs(
    props,
    containsCompletedTransaction(transactions),
  );
  const claimId = props.match.params.claimId;
  const [judgementAddClone, setjudgementAddClone] = useState<
    IJudgementAdd | { status: string }
  >({} as IJudgementAdd | { status: string });

  useDeepCompareEffect(() => {
    setjudgementAddClone(cloneDeep(props.judgementAdd));
  }, [props.judgementAdd, props.currentTabInstance, token]);

  useEffect(() => {
    const claimId = get(props, ['match', 'params', 'claimId']);
    if (!isEmpty(props.judgementAdd) && !isEmpty(props.judgementAddAppeal)) {
      props.requestGetDahirAmountCorpo(claimId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let labesWithIds = constructLabelsWithIds(props.civilProceeding);
  useEffect(() => {
    if (idCivilProceeding != 0) {
      props.civilProceeding.forEach(
        (el: {
          procedureNatureId: number;
          id: number;
          courtNumber: string;
        }) => {
          if (el.id === idCivilProceeding) {
            setIdCivilProceeding(el.id);
            setCurrentJudiciaryProcess(el);
          }
        },
      );
    }
  }, [props.civilProceeding, props.claimRecap]);

  const handleClickVerticalTabs = (tabIndex: number) => {
    props.resetLawyerSteps();
    const idCivilProceeding = labesWithIds[tabIndex]?.id;
    props.civilProceeding.forEach(
      (el: { procedureNatureId: number; id: number; courtNumber: string }) => {
        if (el.id === idCivilProceeding) {
          setIdCivilProceeding(el.id);
          setCurrentJudiciaryProcess(el);
        }
      },
    );
  };

  const labes = constructLabels(props.civilProceeding);

  const handleOpenCivilProceeding = (type: number) => () => {
    setIsDialogOpenCivilProceeding(true);
    setDropDown(null);
    setProcedureType(type);
  };
  const handleOpenUpdateFormCivilProceeding = (payload: any) => {
    setUpdateCivilProcedure(true);
    setIsDialogOpenCivilProceeding(true);
    setProcedureInfo(payload);
  };
  useEffect(() => {
    if (claimId) {
      props.requestGetExpertiseVictim({
        missionId: null,
        claimId,
        missionVictimId: null,
        isIntervenant: true,
        isLegalProceeding: true,
      });
    }
  }, [!claimId, !token, idCivilProceeding]);

  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);
  const [page, setPage] = React.useState<number>(0);

  const handleOpen = () => {
    setIsDialogOpen(true);
  };

  const handleClose = () => {
    setIsDialogOpen(false);
  };

  return (
    <Container>
      <StyledDiv>
        {get(props.claimRecap['claim'], ['suspicious']) &&
          featureService.hasFeature(FEATURES.FRAUDE_CORPO) && (
            <SuspiciousCard />
          )}
        {shouldShowVictimExcludedWarning(
          get(props.claimRecap, 'victims'),
          featureService.hasFeature(FEATURES.IS_VICTIM_EXCLUDED_FROM_COVERAGE),
        ) && (
          <WarningCard
            message={messages.victimExcludedFromCoverageWarningMessage}
          />
        )}
        {!isManager(props) && (
          <TopCard
            claimNumber={get(props.claimRecap['claim'], 'claimNumber', '')}
            claimRecap={props.claimRecap}
            sagisInfo={props.sagisInfo}
            inputProps={{ disableUnderline: true }}
            setDropDown={setDropDown}
            dropDown={dropDown}
            handleOpenCivilProceeding={handleOpenCivilProceeding}
            handleOpenFirmReferenceDialog={() => {}}
            requestSagisClaimInfo={props.requestSagisClaimInfo}
            resetSagisInfoClaim={props.resetSagisInfoClaim}
            displayActionButton={
              !isBlockStatusClaim(props.policyInfo) &&
              !isEmpty(get(props.policyInfo, 'sagis', {}))
            }
          />
        )}
      </StyledDiv>
      {featureService.hasFeature(FEATURES.CIVIL_PROCEEDING) && (
        <CivilProceeding
          setIsDialogOpenCivilProceeding={setIsDialogOpenCivilProceeding}
          requestCreateCivilProceeding={props.requestCreateCivilProceeding}
          procedureType={procedureType}
          isDialogOpenCivilProceeding={isDialogOpenCivilProceeding}
          claimId={claimId}
          resetUploadDocumentStore={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          documentId={props.documentId}
          setDocumentId={props.setDocumentId}
          corporealLawyers={props.corporealLawyers}
          requestCorporealLawyers={props.requestCorporealLawyers}
          claimRecap={props.claimRecap}
          listings={props.listings}
          policyInfo={props.policyInfo}
          sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
          sagisOpposingParties={extractOpposingParties(
            get(props.sagisInfo, 'offeredRisks', []),
          )}
          updateCivilProcedure={updateCivilProcedure}
          procedureInfo={procedureInfo}
          requestUpdateCivilProceeding={props.requestUpdateCivilProceeding}
        />
      )}
      {featureService.hasFeature(FEATURES.INSTRUCTIONS) && (
        <InstructionDrawer
          open={isInstructionDrawerOpen}
          handleToggleDrawer={toggleDrawerInstruction}
          listings={props.listings}
          judiciaryProcess={props.civilProceeding}
          intervenants={get(props.listings, 'intervenants', [])}
          claimRecap={props.claimRecap}
          isManager={false}
          setIsInstructionDrawerOpen={setIsInstructionDrawerOpen}
          judiciaryProcessId={idCivilProceeding}
          claimId={claimId}
          isConsultation={false}
          instructions={props.instructions}
          requestCreateInstruction={props.requestCreateInstruction}
          requestGetInstructions={props.requestGetInstructions}
          instruction={instruction}
          setInstruction={setInstruction}
          isIntervenant
        />
      )}
      <UpdateFirmReferenceDialog
        isDialogOpen={Boolean(get(dialogOpenFirmReference, 'firmReference'))}
        setIsDialogOpen={setDialogOpenFirmReference}
        requestUpdateFirmReference={props.requestUpdateFirmReference}
        claimId={claimId}
        firmReference={get(dialogOpenFirmReference, 'firmReference')}
        judgementId={get(dialogOpenFirmReference, 'judgementId')}
        judgementAddDocumentIds={get(
          dialogOpenFirmReference,
          'judgementAddDocumentIds',
        )}
        lawyerClaimAssignmentId={lawyerClaimAssignmentId}
        isFeeNoteGenerated={get(dialogOpenFirmReference, 'isFeeNoteGenerated')}
        requestCreateFeeNote={props.requestCreateFeeNote}
        feeNote={get(dialogOpenFirmReference, 'feeNote')}
        lawyerFirmReference={get(
          dialogOpenFirmReference,
          'lawyerFirmReference',
        )}
        judiciaryProcessId={idCivilProceeding}
        uploadDocument={props.uploadDocument}
        uploadedDocument={props.uploadedDocument}
        resetUploadedDocument={props.resetUploadDocumentStore}
        listings={props.listings}
        limitInvoiceDate={getLimitInvoiceIntervenant(
          get(props.listings, 'appConfig', []),
        )}
      />
      {featureService.hasFeature(FEATURES.FEE_NOTE) && (
        <DialogFeeNote
          allFeeNote={props.allFeeNote}
          requestAllFeeNotes={() => {}}
          feeNotes={props.feeNotes}
          feeNotesCount={props.feeNotesCount}
          requestLawyerFeeNotes={props.requestFeeNotesByClaimNumb}
          requestCreateFeeNote={props.requestCreateFeeNote}
          requestFeeNoteCosts={props.requestFeeNoteCosts}
          keyclokToken={token}
          resetUploadDocumentStore={props.resetUploadDocumentStore}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          setDocumentId={props.setDocumentId}
          documentId={props.documentId}
          open={isDialogOpen}
          handleClose={handleClose}
          showButtonAdd={false}
          title={translate(messages.FeeNoteTitle, props)}
          claimNumber={get(props.claimRecap, 'claim.claimNumber')}
          listings={props.listings}
          page={page}
          setPage={setPage}
          isExpert={false}
          requestUpdateFeeNoteAmount={props.requestUpdateFeeNoteAmount}
          loaders={props.loaders}
          requestAddInvoiceFeeNote={props.requestAddInvoiceFeeNote}
          requestUpdateInvoiceFeeNote={props.requestUpdateInvoiceFeeNote}
          contractorFeesSagis={getContractorFeesByIntervenant(
            props.sagisInfo,
            (props.sagis_code as unknown) as string,
          )}
          isConsultation={false}
        />
      )}
      {featureService.hasFeature(FEATURES.CIVIL_PROCEEDING) && (
        <SahamTabsGlobal>
          <GlobalLegalProceedingTabs
            currentTabIndex={
              props.globalCurrentTabLawyer ? props.globalCurrentTabLawyer : 0
            }
            labels={labels}
            setCurrentInstanceTab={props.setCurrentInstanceTab}
          >
            <LawyerRecap
              listings={props.listings}
              storedClaimToPreopen={props.storedClaimToPreopen}
              requestClaimRecap={props.requestClaimRecap}
              claimRecap={props.claimRecap}
              policyInfo={props.policyInfo}
              requestSearchClaims={props.requestSearchClaims}
              resetSearchClaimsStore={props.resetSearchClaimsStore}
              claimId={claimId}
              shouldDisplayBreadCrumbs={false}
              className="recap-bloc"
              shouldNotGetClaim
              stakeholders={stakeholders}
              documentId={props.documentId}
              setDocumentId={props.setDocumentId}
              uploadedDocument={props.uploadedDocument}
              uploadDocument={props.uploadDocument}
              setClaimRecap={props.setClaimRecap}
              resetUploadedDocument={props.resetUploadDocumentStore}
              requestAddDocumentClaim={props.requestAddDocumentClaim}
              requestSagisClaimInfo={props.requestSagisClaimInfo}
              sagisInfo={props.sagisInfo}
              keycloakToken={token}
              requestGetReportsPolicy={props.requestGetReportsPolicy}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
            <JudiciaryProcessTabs
              currentTabIndex={getCurrentTabJudiciaryProcess(
                props.currentTabJudiciaryProcessLawyer,
                props.civilProceeding,
              )}
              labels={labes}
              handleClickVerticalTabs={handleClickVerticalTabs}
            >
              {labes.map(label => {
                return (
                  <LegalProceedingsPage
                    {...props}
                    currentJudiciaryProcess={currentJudiciaryProcess}
                    judiciaryProcessId={idCivilProceeding}
                    judgementAddClone={judgementAddClone}
                    expertExpertise={props.expertise}
                    handleOpenUpdateFormCivilProceeding={
                      handleOpenUpdateFormCivilProceeding
                    }
                    setDialogOpenFirmReference={setDialogOpenFirmReference}
                    keycloakToken={token}
                    feeNotes={claimFeeNotes}
                    onPressInstructions={handleOpenInstructions}
                    isAssignedLawyer={
                      !isEmpty(assignedLawyer) &&
                      !isBlockStatusClaim(props.policyInfo)
                    }
                    onPressFeeNote={handleOpen}
                    currentTabLawyer={props.currentTabLawyer}
                  />
                );
              })}
            </JudiciaryProcessTabs>
            {featureService.hasFeature(FEATURES.EXPERT_INTEGRATION) && (
              <ExpertiseExpert
                match={props.match}
                requestMakeDecisionMissionExpertise={
                  props.requestMakeDecisionMissionExpertise
                }
                requestMakeDecisionMissionNoticeDeficiency={
                  props.requestMakeDecisionMissionNoticeDeficiency
                }
                requestFeeNotesByClaimNumb={() => {}}
                claimNumber={get(props.claimRecap, 'claim.claimNumber')}
                isLawyer
                onPressFeeNote={() => {}}
                currentTabManagerExpertise={0}
                riskKey={get(
                  get(props.sagisInfo, 'offeredRisks', []).find(
                    (element: { riskName: string }) =>
                      element.riskName === rcCoporeal,
                  ),
                  'riskId',
                )}
                setOpenFeeNoteDialog={() => {}}
                claimRecap={props.claimRecap}
                resetSearchClaimsStore={props.resetSearchClaimsStore}
                resetStoreClaim={props.resetStoreClaim}
                resetSagisInfoClaim={props.resetSagisInfoClaim}
                resetLegalProceeding={props.resetLegalProceeding}
                policyInfo={props.policyInfo}
                currentIndexTabManager={null}
                currentInstanceTabIndexManager={null}
                currentTabInstance={null}
                requestSearchClaims={props.requestSearchClaims}
                listings={props.listings}
                requestSetPriorityClaimProvision={undefined}
                requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
                requestGetExpertiseVictim={props.requestGetExpertiseVictim}
              />
            )}
            {featureService.hasFeature(FEATURES.EXPERT_INTEGRATION) &&
              containsCompletedTransaction(transactions) && (
                <TransactionConsultation
                  match={props.match}
                  claimNumber={get(
                    props.claimRecap['claim'],
                    'claimNumber',
                    '',
                  )}
                  claimRecap={props.claimRecap}
                  policyInfo={props.policyInfo}
                  requestAddTransaction={() => {}}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadedDocument={props.resetUploadDocumentStore}
                  uploadDocument={props.uploadDocument}
                  requestUpdateTransaction={() => {}}
                  requestAddContactTransaction={() => {}}
                  requestUpdateContactTransaction={() => {}}
                  corporealExperts={[]}
                  requestGetExpertUsers={() => {}}
                  requestAssignedExpert={() => {}}
                  riskKey={get(
                    get(props.sagisInfo, 'offeredRisks', []).find(
                      (element: { riskName: string }) =>
                        element.riskName === rcCoporeal,
                    ),
                    'riskId',
                  )}
                  requestGetMissionTransaction={
                    props.requestGetMissionTransaction
                  }
                  requestMakeDecisionMissionExpertise={
                    props.requestMakeDecisionMissionExpertise
                  }
                  requestGetMissionVictimExpertise={
                    props.requestGetMissionVictimExpertise
                  }
                  requestUpdateMissionTransaction={() => {}}
                  requestGetFeeNotesTransaction={() => {}}
                  onPressFeeNote={() => {}}
                  isConsultation={true}
                  expertJudiciaryExpertise={{}}
                  requestImportMissionExpertise={() => {}}
                  requestGetJudiciaryExpertReport={() => {}}
                  requestMakeDecisionVictimInfo={() => {}}
                  sagisInfo={props.sagisInfo}
                  requestLockClaim={() => {}}
                  setLockedClaim={() => {}}
                  requestSetPriorityClaimProvision={() => {}}
                  requestResetHistoryStore={() => {}}
                  currentIndexTabManager={() => {}}
                  currentInstanceTabIndexManager={() => {}}
                  currentGlobalTabManagerIndex={() => {}}
                  currentJudiciaryProccessId={() => {}}
                  requestGetDahirAmount={props.requestGetDahirAmount}
                  setCurrentIndexTabTransaction={
                    props.setCurrentIndexTabTransaction
                  }
                  requestCreateCorporealRegulation={() => {}}
                  regulations={props.regulations}
                  requestGetRegulation={() => {}}
                  requestGetRegulations={props.requestGetRegulations}
                  requestValidateRegulation={() => {}}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                  requestGetTransaction={props.requestGetTransaction}
                  requestGetContactTransaction={
                    props.requestGetContactTransaction
                  }
                  resetStoreTransaction={props.resetStoreTransaction}
                  requestSagisClaimInfo={props.requestSagisClaimInfo}
                  isIntervenant={true}
                />
              )}
          </GlobalLegalProceedingTabs>
        </SahamTabsGlobal>
      )}
    </Container>
  );
};

const mapDispatchToProps = {
  requestClaimRecap,
  requestSearchClaims,
  resetSearchClaimsStore,
  uploadDocument,
  resetUploadDocumentStore,
  requestCreateJudgementAdd,
  requestValidateJudgementOnMerits,
  requestGetJudgementAdd,
  requestGetJudgementAddAppeal,
  getLegalProceedingsSteps,
  setDocumentId,
  requestCreateExpertiseRaport,
  requestCreateJudgementOnMerits,
  requestGetExpertiseRaport,
  requestGetJudgementOnMerits,
  requestGetJudgementOnMeritsMultiple,
  requestCreateJudgementAppeal,
  requestGetJudgementAppeal,
  requestGetDahirAmount,
  setCurrentInstanceTab,
  requestGetCivilProceeding,
  requestCorporealLawyers,
  requestInsertDahirAmountJom,
  requestGetDahirAmountCorpo,
  updateContestation,
  requestUploadContestationDocument,
  requestCreateCivilProceeding,
  requestCreateMultipleJudgementAdd,
  requestAddDocumentClaim,
  requestAddSupportDocument,
  requestCivilPartySupportDocument,
  requestAddExpertiseSupportDocument,
  requestAddJudgementOnMeritsSupportDocument,
  requestUpdateJudgementAdd,
  requestValidateExpertReport,
  requestUpdateJudgementAddDocument,
  requestUpdateFirmReference,
  setClaimRecap,
  requestGetAppealOnMeritsMultiple,
  requestMakeDecisionMissionExpertise,
  requestMakeDecisionMissionNoticeDeficiency,
  requestGetExpertiseVictim,
  requestCreateFeeNote,
  requestSagisClaimInfo,
  resetLegalProceeding,
  resetStoreClaim,
  resetSagisInfoClaim,
  requestCreateInstruction,
  requestGetInstructions,
  requestUpdateInstruction,
  requestCreateIncomeCertificate,
  requestGetExpertiseReportAppeal,
  requestGetReportsPolicy,
  requestUpdateIncomeCertificate,
  requestGetClaimCivilParty,
  requestFeeNotesByClaimNumb,
  requestAllFeeNotes,
  requestFeeNoteCosts,
  requestUpdateFeeNoteAmount,
  requestAddInvoiceFeeNote,
  requestUpdateInvoiceFeeNote,
  requestGetDocByDocumentumId,
  requestGetJudgements,
  resetLawyerSteps,
  requestGetTransaction,
  requestGetMissionTransaction,
  requestGetMissionVictimExpertise,
  requestGetContactTransaction,
  resetStoreTransaction,
  setCurrentIndexTabTransaction,
  requestUpdateCivilProceeding,
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  claimRecap: makeSelecClaimRecap(),
  policyInfo: makeSelectSearchClaims(),
  uploadedDocument: makeSelectDocument(),
  judgementAdd: makeSelectJudgementAdd(),
  judgementAddAppeal: makeSelectJudgementAddAppeal(),
  currentSteps: makeSelectLegalProceedingsSteps(),
  documentId: makeSelectDocumentId(),
  expertiseReport: makeSelectExpertiseRaport(),
  judgementOnMerits: makeSelectJudgementOnMerits(),
  judgementOnMeritsMultiple: makeSelectJudgementOnMeritsMultiple(),
  judgementAppeal: makeSelectJudgementAppeal(),
  dahirAmount: makeSelectDahirAmounts(),
  currentTabInstance: makeSelectCurrentInstanceTab(),
  civilProceeding: makeSelectCivilProceeding(),
  corporealLawyers: makeSelectCorporealLawyers(),
  dahirAmountsCorpo: makeSelectDahirAmountsCorpo(),
  appealOnMeritsMultiple: makeSelectAppealOnMeritsMultiple(),
  expertise: makeSelectVictimExpertise(),
  loaders: selectedLoader,
  sagisInfo: makeSelectSagisClaim(),
  instructions: makeInstructions(),
  expertiseRaportAppeal: makeSelectExpertiseRaportAppeal(),
  claimCivilParty: makeSelectClaimCivilParty(),
  allFeeNote: makeSelectAllFeeNotes(),
  feeNotes: makeSelectFeeNotes(),
  feeNotesCount: makeSelectCountFeeNotes(),
  globalCurrentTabLawyer: makeSelectGlobalCurrentTabLawyer(),
  currentTabJudiciaryProcessLawyer: makeSelectCurrentTabJudiciaryProcessLawyer(),
  currentTabLawyer: makeSelectCurrentTabLawyer(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(LawyerLegalProceedingsPage));
